var map = {
	"./CDAC.png": 90,
	"./Codecademy.png": 191,
	"./Coursera.jpg": 192,
	"./IBM-cognitive.png": 193,
	"./Microsoft.png": 194,
	"./NPTEL.png": 195,
	"./be.png": 100,
	"./blog.png": 196,
	"./certificate.png": 108,
	"./codechef.png": 197,
	"./codeyantra-website.png": 198,
	"./codeyantra_logo.jpeg": 92,
	"./coding.gif": 109,
	"./eating.gif": 110,
	"./github.png": 96,
	"./gmail.png": 99,
	"./hackerrank.png": 199,
	"./hsc.png": 101,
	"./instagram.png": 98,
	"./linkedin.png": 97,
	"./projIcon.png": 105,
	"./project.png": 200,
	"./repeat.png": 201,
	"./repeating.gif": 111,
	"./skills.png": 202,
	"./sleeping.gif": 112,
	"./slrtce.png": 94,
	"./ssc.png": 102,
	"./stopstalk.png": 203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;